import { network } from '@root/utils'
import { handleReturn, isHttpError } from './root'

export type ExpenseRateUnit = 'per_km' | 'per_km_per_person' | 'per_day'

export type ExpenseClaimRate = {
  rate_type: string
  unit: ExpenseRateUnit
  is_supplement: boolean
  tax_free_amount: string
  own_amount: string | null
  applied_amount: string
  own_rate_exceeds_tax_free: boolean
}

export type ExpenseClaimRates = {
  on_date: string
  year: number
  effective_from: string
  rates_outdated_for_year: boolean
  rates: ExpenseClaimRate[]
}

const ratesUrl = (slug: string) => `/v1/business/${slug}/expense_claims/rates/`

export const fetchExpenseClaimRates = async (slug: string): Promise<ExpenseClaimRates> => {
  const { status, data } = await network.httpClient.request({
    url: ratesUrl(slug),
    method: 'GET',
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

export const saveExpenseClaimRate = async (
  slug: string,
  rateType: string,
  amount: string
): Promise<ExpenseClaimRates> => {
  const { status, data } = await network.httpClient.request({
    url: ratesUrl(slug),
    method: 'PUT',
    data: { rate_type: rateType, amount },
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

export const deleteExpenseClaimRate = async (
  slug: string,
  rateType: string
): Promise<ExpenseClaimRates> => {
  const { status, data } = await network.httpClient.request({
    url: ratesUrl(slug),
    method: 'DELETE',
    data: { rate_type: rateType },
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

export const expenseClaimRateError = (error: unknown): string | null => {
  if (!isHttpError(error)) return null
  const data = error.data as {
    amount?: string[]
    field_errors?: { amount?: string[] }
    message?: string
  }
  const amount = data?.field_errors?.amount ?? data?.amount
  if (Array.isArray(amount) && typeof amount[0] === 'string') return amount[0]
  return null
}
